module.exports = __webpack_public_path__ + "static/media/survey-on-phone-Dutch.87ab50e5.png";